import React, { useState } from "react";
import PlacesAutocomplete from "react-places-autocomplete";

export default function App(props) {
  const {address , setAddress} = props;
  const [list, setList] = useState(false);


  const handleChange = (e) => { setAddress(e); setList(true); props.onFieldTextChange(e, null, null) };
  const handleSelect = (e) => { console.log("handleSelect..", e) };

  const handleSelect1 = (v1, v2, v3) => {
    props.onFieldTextChange(v1, v2, v3)
    setAddress(v1); 
    setList(false)
  };

 

  return (
    <div className="input-group">
      <div className="input-group-prepend">
        <span className="input-group-text">
          <i className="fas fa-globe"></i>
        </span>
      </div>
      <PlacesAutocomplete
        value={address}
        onChange={handleChange}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (

          <>
            <input {...getInputProps({ placeholder: "Type address" })} className="form-control brdrLftNoRafius" />
            {list && address.length > 0 ?
              <div id="suggesstion-box">
                <ul id="google-location-list" className="google_location_list">
                  {/* {loading ? <div>...loading</div> : null} */}
                  {suggestions.map((suggestion ,i) => {
                    const style = {
                      backgroundColor: suggestion.active ? "" : ""
                    };
                    return (<li {...getSuggestionItemProps(suggestion, { style })} onClick={() => handleSelect1(suggestion.description, suggestion.placeId, suggestion.formattedSuggestion.mainText)} key={i}> {suggestion.description}</li>);
                  })}
                </ul>
              </div>
              : ''}


          </>
        )}
      </PlacesAutocomplete>

    </div>
  );
}





